import request from '@/utils/request'

// 登录方法
export function login(data) {
	return request({
		url: '/login',
		headers: {
			isToken: false
		},
		method: 'post',
		data: data
	})
}

// 注册方法
export function register(data) {
	return request({
		url: '/register',
		headers: {
			isToken: false
		},
		method: 'post',
		data: data
	})
}

// 获取用户详细信息
export function getInfo() {
	return request({
		url: '/getInfo',
		method: 'get'
	})
}
// 修改用户信息
export function profile(data) {
	return request({
		url: '/system/user/profile',
		method: 'put',
		data: data
	})
}

// 退出方法
export function logout() {
	return request({
		url: '/logout',
		method: 'post'
	})
}

// 获取验证码
export function getCodeImg() {
	return request({
		url: '/captchaImage',
		headers: {
			isToken: false
		},
		method: 'get',
		timeout: 20000
	})
}

// 短信验证码
export function getCodeSms(phone) {
	return request({
		url: '/v1/business/sendCode?phone=' + phone,
		method: 'get'
	})
}
// 根据字典类型查询字典数据信息
export function getDicts(dictType) {
	return request({
		url: '/system/dict/data/type/' + dictType,
		method: 'get'
	})
}
// 根据地区
export function getArea() {
	return request({
		url: '/system/area/list',
		method: 'get'
	})
}
// 找回密码
export function updatePwdByPhone(data) {
	return request({
		url: '/system/user/profile/updatePwdByPhone',
		method: 'put',
		params: data
	})
}
// 获取加密key
export function obtainPK() {
  return request({
    url: '/obtainPK',
    method: 'post'
  })
}

/**
 * 腾讯验证码校验
 * @param {Object} data - 验证参数 {ticket, randstr}
 * @returns Promise
 */
export function captchaCheck(data) {
  return request({
    url: '/captcha/check',
    headers: {
      isToken: false
    },
    method: 'post',
    data: data
  })
}

/**
 * 发送短信验证码
 * @param {Object} data - 发送短信参数 {phonenumber, ticket}
 * @returns Promise
 */
export function sendSmsCode(data) {
  return request({
    url: '/resource/sms/code',
    headers: {
      isToken: false
    },
    method: 'post',
    data: data
  })
}

